import { ASSET_TYPES } from '@exodus/fiat-client'

export const createFiatAsset = (asset, rampAsset) =>
  asset
    ? {
        currency: rampAsset?.name ?? asset.label,
        label: asset.label,
        name: rampAsset?.name ?? asset.label,
        providers: rampAsset?.providers ?? {},
        symbol: asset.symbol,
        type: rampAsset?.type ?? ASSET_TYPES.fiat,
      }
    : undefined

export const sortAlphaByList = (a, b, list = []) => {
  if (list.includes(a) && list.includes(b)) {
    return list.indexOf(a) - list.indexOf(b)
  }

  if (list.includes(a) && !list.includes(b)) {
    return -1
  }

  if (!list.includes(a) && list.includes(b)) {
    return 1
  }

  return a.localeCompare(b)
}
